<template>
  <tr :class="['clickable']" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span class="lock" :title="$gettext('Sdílená váha. Nelze editovat.')" v-if="!$_updateActionAllowed" />
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed" :title="$gettext('Sdílená váha. Nelze editovat.')" v-translate>Zamčeno</span>

    <td :data-th="'Název' | translate" class="first_data"><strong>{{ entity.name }}</strong></td>
    <td :data-th="'Poslední editace' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td :data-th="'Upravil' | translate">{{ entity.user_updated }}</td>
    <td :data-th="'Počet použití šablony' | translate">{{ entity.number_of_uses }}</td>
    <td :data-th="'Globální oznámení' | translate"><img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
                                                      v-if="entity.global"/></td>
    <td :data-th="'Typ oznámení' | translate">{{ type }}</td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_createActionAllowed"
            class="btn btn_action btn_grey btn_notification"
            :title="'Použít šablonu' | translate"
            @click.prevent.stop="emitUseTemplate"
            v-translate>Použít šablonu
        </a>
        <a
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteTemplate"
            v-if="$_deleteActionAllowed"
            v-translate>Smazat
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import types from "../messages/mixins/types"
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "MessageTemplateRow",
  data() {
    return {
      moduleName: 'messageTemplates',
      detailPageRouteName: 'messageTemplateDetail',
    }
  },
  props: {
    entity: Object
  },
  mixins: [userSettings, types, rowActions],
  computed: {
    type() {
      let type = this.messageTypeOptions.find(o => o.id === this.entity.type)

      return type.text
    }
  },
  methods: {
    goToDetail(e, id) {
      this.$router.push({name: this.detailPageRouteName, params: {id: id}})
    },
    emitDeleteTemplate() {
      this.$emit('deleteTemplate', String(this.entity.id))
    },
    emitUseTemplate() {
      this.$emit('useTemplate', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/MessageTemplateRow.vue